import { Music } from "../Util/Music/Music";
import AllNotes from '../assets/allNotes_high.mp3';
import { allNotes_high_timestamps } from "../assets/allNotes_high_timestamps";
import Buzz from '../assets/incorrect.mp3';
import {Howl} from 'howler';

export interface NotePlayerNote{
    tonic:number,
    time:number,
    octave:number
}
export class NotePlayer{
    static notes:NotePlayerNote[] = allNotes_high_timestamps()
    sound:Howl
    buzzer:Howl
    activeNotes:NotePlayerNote[]
    tonic:number
    volume:number
    constructor(volume:number){
        this.tonic = Music.C
        this.volume = volume
        this.sound = new Howl({src:AllNotes, sprite:this.buildHowlSprite()})
        this.sound.volume(this.volume)
        this.buzzer = new Howl({src:[Buzz]})
        this.buzzer.volume(this.volume)
        this.activeNotes = NotePlayer.notes.concat()
        
    }
    setVolume(vol:number){
        this.volume = vol
        this.buzzer.volume(vol)
        this.sound.volume(vol)
    }
    setTonic(tonic:number){
        this.tonic = tonic
        this.reset()
    }
    reset(){
        this.activeNotes = this.getTonicNotes()
    }
    getTonicNotes(){
        const findIndex = () => {
            return NotePlayer.notes.concat().findIndex((note:NotePlayerNote) => note.tonic === this.tonic)
        }
        let tonicIndex:number = findIndex()
        return(NotePlayer.notes.concat().slice(tonicIndex))
    }
    getId(note:NotePlayerNote){
        const noteName:string = Music.notesFlat[note.tonic]
        const id:string = `${note.octave}_${noteName}`
        return id
    }
    buildHowlSprite(){
        const sprite:any = {}
        const duration:number = 1950
        NotePlayer.notes.forEach((note:NotePlayerNote)=>{
            const id:string = this.getId(note)
            sprite[id] = [note.time, duration]
        })
        return sprite
    }
    getNextNoteIndex(tonic:number){
        const findIndex = () => {
            return this.activeNotes.findIndex((note:NotePlayerNote) => note.tonic === tonic)
        }
        let nextNoteIndex:number = findIndex()
        if(nextNoteIndex < 0){
            this.reset()
            nextNoteIndex = findIndex()
        }
        return nextNoteIndex
    }
    findNextNoteID(noteTonic:number, nextOctave?:boolean){
        let nextNoteIndex:number = this.getNextNoteIndex(noteTonic)
        if(nextOctave){
            nextNoteIndex += 12
        }
        const id:string = this.getId(this.activeNotes[nextNoteIndex])
        if(!nextOctave){this.chopActiveNotes(nextNoteIndex)}
        return id
    }
    chopActiveNotes(index:number){
        this.activeNotes = this.activeNotes.slice(index)
    }
    playNote(tonic:number, reset?:boolean, nextOctave?:boolean){
        if(reset){this.reset()}
        const id:string = this.findNextNoteID(tonic, nextOctave)
        this.sound.play(id)
    }
    playDescendingNotes(notes:number[], reset:boolean, waitTime:number){
        if(reset){this.reset()}
        const ids:string[] = []
        const reversedNotes:number[] = notes.reverse()
        reversedNotes.forEach((note:number, index:number)=>{
            if(!reset && index === 0){
                this.setTonic(note)
            }
            ids.push(this.findNextNoteID(note))
            if(reset){this.reset()}
        })
        ids.reverse().forEach((id:string, index:number)=>{
            setTimeout(()=>{this.sound.play(id)}, index * waitTime)
        })
    }
    playNotes(notes:number[], reset?:boolean, waitTime?:number){
        if(reset){this.reset()}
        const wait:number = (waitTime) ? waitTime : 1000
        notes.forEach((note:number, index)=>{
            setTimeout(()=>{this.playNote(note)}, index * wait)
        })
    }
    playChord(noteTonics:number[], reset?:boolean){
        if(reset){this.reset()}
        const ids:string[] = []
        noteTonics.forEach((note:number, index:number)=>{
            if(!reset && index === 0){
                this.setTonic(note)
            }
            const nextOctave:boolean = (index > 2 && note < noteTonics[index - 1])
            ids.push(this.findNextNoteID(note, nextOctave))
            if(reset){this.reset()}
        })
        ids.forEach((id:string)=>{
            this.sound.play(id)
        })
    }
    playBuzzer(){
        this.buzzer.play()
        //this.sound.fade(1,0,1600)
    }
}